module.exports = __webpack_public_path__ + "img/introducePageEight_show_four.38b3b228.png";